<template>
    <v-card class="score-chart ma-1">
        <v-container>
            <v-card flat class="ma-1 pa-2 score-trans">
                <v-responsive>
                    <div v-if="current_size != 'xs'">
                        <v-row cols="12" dense>
                            <v-col cols="8">
                                <v-card-title dense class="caption-font">Occupancy <div v-if="isAgent" style="font-size: medium; font-weight: 500;" class="ml-2">for your accommodations ({{ this.accocount }})</div></v-card-title>                                                      
                                <v-card-subtitle>Based on marketing level for the coming three months</v-card-subtitle>
                            </v-col>    
                            <v-spacer></v-spacer>                    
                            <v-col cols="4">
                                <v-select v-model="selcountry" :items="countrylist" item-value="landcode" item-text="description" dense v-on:change="getAvailabilityData('refresh')"></v-select>
                                <btn_create_excel v-if="isAgent && accocount!==0" :report_program="report" :report_request="report_request" :report_params="report_params" :show_progress="true"/>
                            </v-col>                                     
                        </v-row>
                    </div>
                    <div v-else>
                        <v-row cols="12" dense>
                            <v-col cols="12">
                                <v-card-title dense class="caption-font-xs">Occupancy<br><span class="intro-font-xs">Based on marketing level for the upcoming three months</span></v-card-title>                                                      
                            </v-col>    
                        </v-row>
                        <v-row cols="12" dense>
                                <v-col cols="8">
                                    <v-select class="margin-xs" v-model="selcountry" :items="countrylist" item-value="landcode" item-text="description" dense v-on:change="getAvailabilityData('refresh')"></v-select>
                                </v-col>                                     
                        </v-row>
                    </div>
                    <v-card flat class="score-semitrans-25">
                    <v-container v-if="showchart">
                        <div style="height: 250px; width: 100%;">
                            <canvas id="availability-pie-chart"></canvas>
                        </div>
                    </v-container>
                    <v-container v-else>
                        <div style="height: 250px; width: 100%; display: flex; align-items: center; justify-content: center;">
                            <div style="text-align: center; border: 1px solid red; padding: 10px !important; border-radius: 15px;"><div>No pie-chart showing?</div><div>You may be registered as an agent incorrectly or configuration is missing</div></div>                        
                        </div>    
                    </v-container>
                    </v-card>
                </v-responsive>
            </v-card>
            <v-card-actions></v-card-actions>
        </v-container>
    </v-card>
</template>

<script>

    import mxbookingschart from '../mixins/availability_chart';
    import btn_create_excel from "@/components/ui/buttons/btn_create_excel.vue";

    import { Chart, registerables } from 'chart.js'
    Chart.register(...registerables)    

    import {bus} from "../../../../main";

    export default {
        computed:{
            current_size: function(){
                return this.$vuetify.breakpoint.name;
            }
        },               
        data() {
            return {
                countrylist: [],
                availability_country: [],
                selcountry: 'All',
                chart: null,
                isAgent: false,
                accocount: 0,
                showchart: true,
                report: "ares/json/ares/syst/dashboard/excelExportAvailabilityv1.p",
                report_params: {
                    stat_codes: ['D','DP'],
                    bedr_codes: ['IH','VFY'],
                },                    
                report_request: "excelExportList1",                
            }
        },
        components: {
            btn_create_excel
        },
        created(){ // set up event bus listener here on created event
            this.getAvailabilityData('load');
            bus.$on("refresh", (data) => {
                 console.log("refresh received for availability0 " + data);
                //this.getBookingData('refresh');                
            });
        },                  
        mounted(){            

        },    
        mixins:[mxbookingschart],
        methods:{
            refreshChart(object){
                this.chart.data.labels = object.data.labels;
                let i = 0;
                this.chart.data.datasets.forEach((dataset) => {
                   dataset.data = object.data.datasets[i].data;
                   i++;
                });
                this.chart.options = object.options;
                this.chart.update();
            },
            getAvailabilityData(param){  
                // console.log("param " + param);          
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getAvailabilityv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAvailability"
                    },
                    })
                    .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {  
                        // console.log(res.data)
                        this.isAgent = res.data.header.isAgent;
                        this.accocount = res.data.header.acco_count;
                        this.countrylist = res.data.getAvailability.countrylist;    
                        this.availability_country = res.data.getAvailability.countries;
                        this.accocount!==0?this.showchart=true:this.showchart=false;
                        if(this.showchart){
                            if(param ==='load'){
                                const ctx = document.getElementById('availability-pie-chart').getContext('2d');
                                this.chart = new Chart(ctx, this.createBarData(this.availability_country, 'pie', this.selcountry));                               
                            } else {
                                this.refreshChart(this.createBarData(this.availability_country, 'pie', this.selcountry));
                            }
                        }
                    }
                    })
                    .finally(() => {});
            },             
        }
    }
</script>

<style scoped>
    .score-chart {
        background: url('../assets/tile_morning.png') !important;
        background-size: cover !important;
    }
    .intro-font {
        font-size: 15px;
    }
    .intro-font-xs {
        font-size: 12px;
    }    
    .caption-font {
        font-size: 30px;
        font-weight: bold;
        display: flex; 
        flex-direction: row; 
        align-items: baseline;        
    }
    .caption-font-xs {
        font-size: 20px;
        font-weight: bold;
    }  
    .margin-xs {
        margin-left: 15px;
    }
    .score-trans {
        background: transparent !important;
    }
    .score-semitrans-25 {
        background-color: rgba(200, 247, 197, 0.50);
    }       
</style>